document.addEventListener('DOMContentLoaded', function() {
    // Only run this script on two-tone products
    if (!document.querySelector('[data-fabric-display="1"]')) {
        return;
    }
    
    // Configuration object for better organization
    const config = {
        materialSlotPrefix: 'Material ',
        swatchContainerPrefix: 'swatch-container-',
        baseMaterialsCache: new Map(),
        textureCache: new Map()
    };
    
    // Add CSS to hide default variant selectors for second option and lazy loading styles
    addVariantHidingStyles();
    
    // Cache DOM elements for secondary fabric
    const fabricPreview = document.querySelector('[data-fabric-preview="1"]');
    const previewImage = fabricPreview.querySelector('[data-preview-image]');
    const previewTitle = fabricPreview.querySelector('[data-preview-title]');
    const previewDescription = fabricPreview.querySelector('[data-preview-description]');
    const jsonLoader = document.getElementById('json-loader-1');
    const sliderContainer = document.querySelector('#swatch-container-1');
    const sliderWrapper = sliderContainer ? sliderContainer.querySelector('.fabric-swiper-wrapper') : null;
    const selectedFabricInput = document.getElementById("selected-fabric-secondary");
    
    // Store the currently selected fabric information
    let lastSelectedFabric = {
        fabricType: '',
        code: '',
        imageUrl: '',
        composition: '',
        isDirect: false
    };
    
    // Intersection Observer for lazy loading
    let imageObserver = null;
    
    // ============= NEW UNIFIED MATERIAL SYSTEM =============
    
    /**
     * Get the texture source for any option (swatch or standard)
     */
    function getTextureForOption(optionIndex, selectedValue, optionElement) {
        // Priority 1: Check if this is a swatch system
        const swatchContainer = document.querySelector(`#${config.swatchContainerPrefix}${optionIndex}`);
        if (swatchContainer) {
            const selectedSwatch = swatchContainer.querySelector('.swatches__form--label.selected');
            if (selectedSwatch) {
                const url = selectedSwatch.dataset.lazyImage || extractImageUrl(selectedSwatch.style.backgroundImage);
                return {
                    url: url,
                    type: 'swatch',
                    properties: {}
                };
            }
        }
        
        // Priority 2: Check base materials configuration
        const baseMaterial = lookupBaseMaterial(optionIndex, selectedValue);
        if (baseMaterial && baseMaterial.texture_handle) {
            const url = baseMaterial.texture_handle.startsWith('/') ?
                `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${baseMaterial.texture_handle}` :
                baseMaterial.texture_handle;
            
            return {
                url: url,
                type: 'base-material',
                properties: baseMaterial.properties || {}
            };
        }
        
        // Priority 3: Check variant's own image
        const normalizedValue = selectedValue.toLowerCase().replace(/\s+/g, '-');
        if (window.variantImageMap && window.variantImageMap[normalizedValue]) {
            const url = window.variantImageMap[normalizedValue];
            return {
                url: url,
                type: 'variant-image',
                properties: {}
            };
        }
        
        return null;
    }
    
    /**
     * Lookup base material from configuration
     */
    function lookupBaseMaterial(optionIndex, selectedValue) {
        // Check if materials are already loaded
        const materials = config.baseMaterialsCache.get(optionIndex);
        if (materials) {
            const material = materials[selectedValue];
            return material;
        } else {
            return null;
        }
    }
    
    /**
     * Pre-load all base materials on initialization
     */
    async function preloadBaseMaterials() {
        const config3D = document.getElementById('3d-config-data');
        if (!config3D) return;
        
        const baseMaterialsJsonUrl = config3D.dataset.baseMaterialsJsonUrl;
        if (!baseMaterialsJsonUrl) return;
        
        try {
            const response = await fetch(baseMaterialsJsonUrl);
            if (!response.ok) return;
            
            const data = await response.json();
            const productVendor = config3D.dataset.productVendor;
            const vendorData = data[productVendor];
            
            if (vendorData && vendorData.materials) {
                // Store materials for option 2 (Secondary Fabric)
                config.baseMaterialsCache.set(2, vendorData.materials);
            }
        } catch (error) {
            // Silent fail
        }
    }
    
    /**
     * Universal texture application function
     */
    function applyTextureToMaterial(modelViewer, textureUrl, materialName, materialProperties = {}) {
        // Add cache-busting parameter to force fresh requests
        const cacheBustUrl = textureUrl + (textureUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
        
        if (!modelViewer.loaded) {
            modelViewer.addEventListener('load', () => {
                applyTextureToMaterial(modelViewer, textureUrl, materialName, materialProperties);
            }, { once: true });
            return;
        }
        
        // Find material by name
        const materialIndex = modelViewer.model.materials.findIndex(
            mat => mat.name === materialName
        );
        
        if (materialIndex === -1) {
            return; // Material not found, silent fail
        }
        
        // Pre-load the image with explicit crossOrigin setting
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = function() {
            // Create texture using model-viewer's createTexture method
            modelViewer.createTexture(cacheBustUrl).then(texture => {
                // Get the specific material by index
                const material = modelViewer.model.materials[materialIndex];
                
                if (!material) return;
                
                // Access the pbrMetallicRoughness using its Symbol
                const pbrSymbol = Object.getOwnPropertySymbols(material).find(
                    s => String(s) === 'Symbol(pbrMetallicRoughness)'
                );
                
                if (pbrSymbol) {
                    const pbr = material[pbrSymbol];
                    
                    // Apply material properties if provided
                    if (materialProperties.roughness !== undefined) {
                        pbr.roughnessFactor = materialProperties.roughness;
                    }
                    if (materialProperties.metalness !== undefined) {
                        pbr.metallicFactor = materialProperties.metalness;
                    }
                    
                    // Find the baseColorTexture symbol
                    const baseColorTextureSymbol = Object.getOwnPropertySymbols(pbr).find(
                        s => String(s) === 'Symbol(baseColorTexture)'
                    );
                    
                    if (baseColorTextureSymbol) {
                        // Get the current texture object
                        const currentTexture = pbr[baseColorTextureSymbol];
                        
                        // Update the texture
                        if (currentTexture && typeof currentTexture.setTexture === 'function') {
                            currentTexture.setTexture(texture);
                        } else {
                            // Try direct assignment
                            pbr[baseColorTextureSymbol] = texture;
                        }
                        
                        // Trigger material update
                        const onUpdateSymbol = Object.getOwnPropertySymbols(material).find(
                            s => String(s) === 'Symbol(onUpdate)'
                        );
                        if (onUpdateSymbol && typeof material[onUpdateSymbol] === 'function') {
                            material[onUpdateSymbol]();
                        }
                    }
                }
            }).catch(error => {
                // Silent fail
            });
        };
        
        img.onerror = function(e) {
            // Try to proceed anyway with createTexture directly
            modelViewer.createTexture(cacheBustUrl).then(texture => {
                // Apply texture logic...
            }).catch(error => {
                // Silent fail
            });
        };
        
        // Start loading the image
        img.src = cacheBustUrl;
    }
    
    /**
     * Handle any option change (unified handler)
     */
    function handleOptionChange(optionIndex, selectedValue, optionElement) {
        const modelViewer = document.querySelector('modern-viewer');
        if (!modelViewer) return;
        
        const textureInfo = getTextureForOption(optionIndex, selectedValue, optionElement);
        if (textureInfo && textureInfo.url) {
            const materialName = `${config.materialSlotPrefix}${optionIndex + 1}`;
            applyTextureToMaterial(modelViewer, textureInfo.url, materialName, textureInfo.properties);
        }
    }
    
    /**
     * Setup universal option listeners
     */
    function setupUniversalOptionListeners() {
        // Find all option groups
        const allOptionGroups = document.querySelectorAll('.swatch');
        
        allOptionGroups.forEach((group) => {
            // Get the actual option index from the data attribute
            const optionIndex = parseInt(group.dataset.optionIndex);
            
            // Skip if this is a swatch-handled option
            if ((optionIndex === 1 && sliderContainer) || (optionIndex === 2 && sliderContainer)) {
                return; // This is handled by swatch system
            }
            
            // Listen to standard variant selectors
            const inputs = group.querySelectorAll('input[type="radio"]');
            inputs.forEach(input => {
                input.addEventListener('change', function() {
                    if (!this.checked) return;
                    
                    const labelElement = document.querySelector(`label[for="${this.id}"]`);
                    const optionValue = labelElement ? labelElement.textContent.trim() : this.value;
                    
                    handleOptionChange(optionIndex, optionValue, this);
                });
            });
            
            // Trigger initial texture application if option is already selected
            const checkedInput = group.querySelector('input:checked');
            if (checkedInput) {
                const labelElement = document.querySelector(`label[for="${checkedInput.id}"]`);
                const optionValue = labelElement ? labelElement.textContent.trim() : checkedInput.value;
                setTimeout(() => handleOptionChange(optionIndex, optionValue, checkedInput), 100);
            }
        });
    }
    
    // ============= END NEW UNIFIED MATERIAL SYSTEM =============
    
    // Create and show loading indicator
    function showLoadingIndicator() {
        // Add loading state to container
        if (sliderContainer) {
            sliderContainer.classList.add('loading');
            
            // Create loading spinner HTML
            const loadingHTML = `
                <div class="fabric-loading-indicator" data-swatch-loading="1">
                    <div class="fabric-loading-spinner">
                        <svg class="spinner" viewBox="0 0 50 50">
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                        </svg>
                    </div>
                    <p class="fabric-loading-text">Loading secondary fabric options...</p>
                </div>
            `;
            
            // Insert loading indicator before the wrapper
            sliderWrapper.insertAdjacentHTML('beforebegin', loadingHTML);
            
            // Hide navigation buttons while loading
            const navButtons = sliderContainer.querySelectorAll('.fabric-nav-btn');
            navButtons.forEach(btn => {
                btn.style.opacity = '0.5';
                btn.disabled = true;
            });
        }
        
        // Add loading state to preview if it exists
        if (fabricPreview) {
            fabricPreview.classList.add('loading');
            
            // Create preview loading indicator
            const previewLoadingHTML = `
                <div class="fabric-preview-loading" data-preview-loading="1">
                    <div class="fabric-loading-spinner">
                        <svg class="spinner" viewBox="0 0 50 50">
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                        </svg>
                    </div>
                </div>
            `;
            
            fabricPreview.insertAdjacentHTML('afterbegin', previewLoadingHTML);
            
            // Hide preview content while loading
            if (previewImage) previewImage.style.display = 'none';
            const previewDetails = fabricPreview.querySelector('.fabric-preview__details');
            if (previewDetails) previewDetails.style.display = 'none';
        }
    }
    
    // Hide loading indicator
    function hideLoadingIndicator() {
        // Remove loading state from container
        if (sliderContainer) {
            sliderContainer.classList.remove('loading');
            
            // Remove loading spinner
            const loadingEl = sliderContainer.querySelector('[data-swatch-loading]');
            if (loadingEl) {
                loadingEl.remove();
            }
            
            // Re-enable navigation buttons
            const navButtons = sliderContainer.querySelectorAll('.fabric-nav-btn');
            navButtons.forEach(btn => {
                btn.style.opacity = '1';
                btn.disabled = false;
            });
        }
        
        // Remove loading state from preview
        if (fabricPreview) {
            fabricPreview.classList.remove('loading');
            
            // Remove preview loading spinner
            const previewLoading = fabricPreview.querySelector('[data-preview-loading]');
            if (previewLoading) {
                previewLoading.remove();
            }
            
            // Show preview content
            if (previewImage) previewImage.style.display = 'block';
            const previewDetails = fabricPreview.querySelector('.fabric-preview__details');
            if (previewDetails) previewDetails.style.display = 'block';
        }
    }
    
    // Initialize Intersection Observer for lazy loading
    function initializeImageObserver() {
        const options = {
            root: null,
            rootMargin: '50px',
            threshold: 0.01
        };
        
        imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const swatch = entry.target;
                    loadSwatchImage(swatch);
                    observer.unobserve(swatch);
                }
            });
        }, options);
    }
    
    // Load swatch image
    function loadSwatchImage(swatch) {
        const imageUrl = swatch.dataset.lazyImage;
        if (!imageUrl) return;
        
        // Create a new image to test loading
        const img = new Image();
        
        img.onload = function() {
            // Image loaded successfully
            swatch.style.backgroundImage = `url('${imageUrl}')`;
            swatch.classList.add('loaded');
            swatch.classList.remove('loading');
        };
        
        img.onerror = function() {
            // Try fallback images
            const variantFallback = swatch.dataset.variantFallback;
            const fabricType = swatch.dataset.fabricType;
            
            if (variantFallback) {
                // Try variant fallback
                const fallbackImg = new Image();
                
                fallbackImg.onload = function() {
                    swatch.style.backgroundImage = `url('${variantFallback}')`;
                    swatch.classList.add('loaded');
                    swatch.classList.remove('loading');
                };
                
                fallbackImg.onerror = function() {
                    // Try final fallback
                    if (fabricType) {
                        const finalFallback = `https://www.danishdesignstore.com/cdn/shop/files/${fabricType.toLowerCase().replace(/\s+/g, '-').replace(/[\(\)]/g, '')}.jpg`;
                        swatch.style.backgroundImage = `url('${finalFallback}')`;
                    }
                    swatch.classList.add('loaded');
                    swatch.classList.remove('loading');
                };
                
                fallbackImg.src = variantFallback;
            } else if (fabricType) {
                // Go straight to final fallback
                const finalFallback = `https://www.danishdesignstore.com/cdn/shop/files/${fabricType.toLowerCase().replace(/\s+/g, '-').replace(/[\(\)]/g, '')}.jpg`;
                swatch.style.backgroundImage = `url('${finalFallback}')`;
                swatch.classList.add('loaded');
                swatch.classList.remove('loading');
            } else {
                // No fallbacks available, just mark as loaded
                swatch.classList.add('loaded');
                swatch.classList.remove('loading');
            }
        };
        
        // Start loading
        swatch.classList.add('loading');
        img.src = imageUrl;
    }

// Automatically select the first available swatch
function selectFirstSwatch() {
    // Find the first swatch element within the secondary fabric container
    const firstSwatch = document.querySelector('#swatch-container-1 .swatches__form--label, #swatch-container-1 .swatch-item-inner');
    if (firstSwatch) {
        // For the first swatch, load image immediately
        if (firstSwatch.dataset.lazyImage && !firstSwatch.classList.contains('loaded')) {
            loadSwatchImage(firstSwatch);
        }
        
        const fabricType = firstSwatch.dataset.fabricType;
        const code = firstSwatch.dataset.swatchCode;
        const displayName = firstSwatch.dataset.displayName;
        const isDirect = firstSwatch.classList.contains('direct-swatch');
        
        if (fabricType && code) {
            // Find composition if available
            let composition = '';
            const groupElement = firstSwatch.closest('.swatches__form--group') || firstSwatch.closest('.fabric-slide');
            if (groupElement) {
                const compositionElement = groupElement.querySelector('.group_composition');
                if (compositionElement) {
                    composition = compositionElement.textContent;
                }
            }
            
            // Get image URL
            let imageUrl = firstSwatch.dataset.lazyImage || 
                `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${fabricType.toLowerCase().replace(/\s+/g, '-').replace(/[\(\)]/g, '')}.jpg`;
            
            // Update preview with all the necessary parameters
            updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName);
            
            // Force update the secondary fabric input
            if (selectedFabricInput && !selectedFabricInput.value) {
                let fabricValue = "";
                if (currentProcessingStrategy === 'upholsteryGroup') {
                    fabricValue = `${fabricType} - ${code}`;
                } else if (currentProcessingStrategy === 'upholstery') {
                    fabricValue = code;
                } else if (currentProcessingStrategy === 'direct') {
                    fabricValue = "";
                }
                selectedFabricInput.value = fabricValue;
            }
            
            // Use unified handler for 3D update - secondary fabric is option 2
            handleOptionChange(2, fabricType, firstSwatch);
        }
    }
}

    // Inject CSS to hide default variant selectors and add lazy loading styles
    function addVariantHidingStyles() {
        // Create a style element
        const styleEl = document.createElement('style');
        styleEl.type = 'text/css';
        
        // Add CSS rules including lazy loading styles and loading indicators
        styleEl.innerHTML = `
            /* Hide option 2 default display only when custom swatches are active */
            .custom-swatch-active-secondary .swatch[data-option-index="2"] .swatch-element {
                display: none !important;
            }
            .custom-swatch-active-secondary .swatch[data-option-index="2"] .option-label {
                display: none !important;
            }
            
            /* Lazy loading styles for secondary fabric */
            #swatch-container-1 .swatches__form--label {
                background-color: #f0f0f0;
                background-size: cover;
                background-position: center;
                transition: opacity 0.3s ease;
            }
            
            #swatch-container-1 .swatches__form--label.loading {
                background-image: none !important;
                position: relative;
            }
            
            #swatch-container-1 .swatches__form--label.loading::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 20px;
                height: 20px;
                margin: -10px 0 0 -10px;
                border: 2px solid #ddd;
                border-top-color: #333;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }
            
            #swatch-container-1 .swatches__form--label.loaded {
                animation: fadeIn 0.3s ease;
            }
            
            /* Loading indicator styles */
            #swatch-container-1 .fabric-loading-indicator {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 40px 20px;
                text-align: center;
            }
            
            #swatch-container-1 .fabric-loading-spinner {
                width: 40px;
                height: 40px;
                margin-bottom: 16px;
            }
            
            #swatch-container-1 .fabric-loading-spinner .spinner {
                animation: rotate 1.4s linear infinite;
            }
            
            #swatch-container-1 .fabric-loading-spinner circle {
                stroke: #333;
                stroke-dasharray: 125;
                stroke-dashoffset: 125;
                animation: dash 1.4s ease-in-out infinite;
            }
            
            #swatch-container-1 .fabric-loading-text {
                color: #666;
                font-size: 14px;
                margin: 0;
            }
            
            #swatch-container-1 .fabric-preview-loading {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 10;
            }
            
            #swatch-container-1.fabric-swiper-container.loading .fabric-swiper-wrapper {
                opacity: 0;
                visibility: hidden;
            }
            
            @keyframes spin {
                to { transform: rotate(360deg); }
            }
            
            @keyframes fadeIn {
                from { opacity: 0.7; }
                to { opacity: 1; }
            }
            
            @keyframes rotate {
                100% { transform: rotate(360deg); }
            }
            
            @keyframes dash {
                0% {
                    stroke-dashoffset: 125;
                }
                50% {
                    stroke-dashoffset: 0;
                }
                100% {
                    stroke-dashoffset: -125;
                }
            }
        `;
        
        // Append to the document head
        document.head.appendChild(styleEl);
    }

    function setSecondaryCustomSwatchMode(enabled) {
        if (!document.body) return;
        document.body.classList.toggle('custom-swatch-active-secondary', Boolean(enabled));

        const customDisplay = sliderContainer ? sliderContainer.closest('[data-fabric-display="1"]') : null;
        if (customDisplay) {
            customDisplay.style.display = enabled ? '' : 'none';
        }
    }

    function safeJsonParse(value, fallbackValue) {
        if (!value) return fallbackValue;
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallbackValue;
        }
    }

    function normalizeString(value) {
        return (value || '').toString().trim();
    }

    function normalizeLower(value) {
        return normalizeString(value).toLowerCase();
    }

    function toHandleKey(value) {
        return normalizeLower(value)
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function parsePossibleJsonArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (!trimmed) return [];
            try {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return trimmed.split(',').map(item => item.trim()).filter(Boolean);
            }
        }
        return [];
    }

    function getMetaobjectField(entry, fieldKey) {
        if (!entry) return '';

        if (entry[fieldKey] !== undefined && entry[fieldKey] !== null) {
            return entry[fieldKey];
        }

        if (entry.fields && Array.isArray(entry.fields)) {
            const match = entry.fields.find(field => normalizeLower(field && field.key) === normalizeLower(fieldKey));
            if (match && match.value !== undefined) {
                return match.value;
            }
        }

        const prefixedKey = `field_${fieldKey}`;
        if (entry[prefixedKey] !== undefined && entry[prefixedKey] !== null) {
            return entry[prefixedKey];
        }

        return '';
    }

    function buildMetaobjectIndexes(swatchMetaobjects, upholsteryVariantMetaobjects) {
        const swatchIndex = new Map();
        const upholsteryVariantIndex = new Map();

        (swatchMetaobjects || []).forEach(item => {
            const idCandidates = [
                item && item.id,
                item && item.handle,
                getMetaobjectField(item, 'swatch_code'),
                getMetaobjectField(item, 'name'),
                getMetaobjectField(item, 'web_name')
            ];
            idCandidates.forEach(candidate => {
                const key = normalizeLower(candidate);
                if (key) swatchIndex.set(key, item);
            });
        });

        (upholsteryVariantMetaobjects || []).forEach(item => {
            const idCandidates = [
                item && item.id,
                item && item.handle,
                getMetaobjectField(item, 'variant_name'),
                getMetaobjectField(item, 'display_name')
            ];
            idCandidates.forEach(candidate => {
                const key = normalizeLower(candidate);
                if (key) upholsteryVariantIndex.set(key, item);
                const handleKey = toHandleKey(candidate);
                if (handleKey) upholsteryVariantIndex.set(handleKey, item);
            });
        });

        return { swatchIndex, upholsteryVariantIndex };
    }

    function resolveUpholsterySourceConfig(optionTitle, upholsteryTypeRaw, handlePatternRaw) {
        const upholsteryTypeList = Array.isArray(upholsteryTypeRaw) ? upholsteryTypeRaw : [];
        const handlePatternList = Array.isArray(handlePatternRaw) ? handlePatternRaw : [];
        const optionKey = normalizeLower(optionTitle);

        let sourceType = '';
        for (const item of upholsteryTypeList) {
            if (!item || typeof item !== 'object') continue;
            const itemKey = Object.keys(item).find(key => normalizeLower(key) === optionKey);
            if (itemKey) {
                sourceType = normalizeLower(item[itemKey]).replace(/["']/g, '');
                break;
            }
        }

        let patterns = [];
        for (const item of handlePatternList) {
            if (!item || typeof item !== 'object') continue;
            const itemKey = Object.keys(item).find(key => normalizeLower(key) === optionKey);
            if (itemKey) {
                const rawValue = item[itemKey];
                patterns = parsePossibleJsonArray(rawValue);
                if (patterns.length === 0 && typeof rawValue === 'string') {
                    patterns = rawValue.split(',').map(v => v.trim()).filter(Boolean);
                }
                break;
            }
        }

        return { sourceType, patterns };
    }

    function buildFabricFromVariantMetaobject(variantMetaobject, swatchIndex) {
        if (!variantMetaobject) return null;

        const variantName = normalizeString(getMetaobjectField(variantMetaobject, 'variant_name'));
        if (!variantName) return null;

        const displayName = normalizeString(getMetaobjectField(variantMetaobject, 'display_name')) || variantName;
        const swatchRefs = parsePossibleJsonArray(getMetaobjectField(variantMetaobject, 'swatches'));

        const swatches = swatchRefs.map(ref => {
            if (ref && typeof ref === 'object') {
                const refName = normalizeString(ref.name || ref.Swatch_Name || ref.swatch_name);
                const refWebName = normalizeString(ref.web_name || ref.Web_Name || refName);
                const refUrl = normalizeString(ref.url || ref.Link_Handle || ref.link_handle);
                if (refWebName && refUrl) {
                    return {
                        Swatch_Name: refName || refWebName,
                        Web_Name: refWebName,
                        Link_Handle: refUrl
                    };
                }
            }

            if (typeof ref === 'string' && /^(https?:)?\/\//.test(ref)) {
                const directName = ref.split('/').pop() || ref;
                return {
                    Swatch_Name: directName,
                    Web_Name: directName,
                    Link_Handle: ref
                };
            }

            const swatchMetaobject = swatchIndex.get(normalizeLower(ref));
            if (!swatchMetaobject) return null;

            const swatchName = normalizeString(getMetaobjectField(swatchMetaobject, 'name'));
            const swatchWebName = normalizeString(getMetaobjectField(swatchMetaobject, 'web_name')) || swatchName;
            const swatchUrl = normalizeString(getMetaobjectField(swatchMetaobject, 'url'));
            if (!swatchWebName || !swatchUrl) return null;

            return {
                Swatch_Name: swatchName || swatchWebName,
                Web_Name: swatchWebName,
                Link_Handle: swatchUrl
            };
        }).filter(Boolean);

        if (swatches.length === 0) return null;

        return {
            Upholstery_Variant: variantName,
            Display_Name: displayName,
            Composition: normalizeString(getMetaobjectField(variantMetaobject, 'composition')),
            Durability: normalizeString(getMetaobjectField(variantMetaobject, 'durability')),
            Designer: normalizeString(getMetaobjectField(variantMetaobject, 'designer')),
            Notes: normalizeString(getMetaobjectField(variantMetaobject, 'notes')),
            Swatches: swatches
        };
    }

    function buildMetaobjectDataForGroupVariants(configData, productSetMetaobjects, indexes, productHandle, productVendor, optionValues) {
        const groupData = [];
        const groups = {};
        const uniqueVariants = new Set();
        const productSetList = Array.isArray(productSetMetaobjects) ? productSetMetaobjects : [];
        const vendorHandle = toHandleKey(productVendor);
        const categorized = categorizeVariants(optionValues || []);
        const regularOptions = (categorized.regular && categorized.regular.options) || [];
        const configuredPatterns = (configData.patterns || []).map(v => normalizeString(v)).filter(Boolean);
        const patternTokens = configuredPatterns.length > 0 ? configuredPatterns : ['all-products'];

        // Primary lookup path: <vendor>-<handle_pattern>-<option-handle>
        regularOptions.forEach(optionValue => {
            const optionLabel = normalizeString(optionValue);
            if (!optionLabel) return;
            const optionHandle = toHandleKey(optionLabel);
            if (!optionHandle) return;

            const candidateHandles = patternTokens
                .map(pattern => toHandleKey(pattern))
                .filter(Boolean)
                .map(patternHandle => `${vendorHandle}-${patternHandle}-${optionHandle}`);

            if (candidateHandles.length === 0) return;

            const matchedProductSet = productSetList.find(item => {
                const itemHandle = normalizeLower(item && item.handle);
                const itemSetHandle = normalizeLower(getMetaobjectField(item, 'product_set_handle'));
                const itemCandidates = [itemHandle, itemSetHandle].filter(Boolean);
                return itemCandidates.some(candidate => candidate && candidateHandles.includes(candidate));
            });

            if (!matchedProductSet) return;

            const variantRefs = parsePossibleJsonArray(getMetaobjectField(matchedProductSet, 'variants'));
            const includes = [];

            variantRefs.forEach(ref => {
                const variantKey = normalizeLower(ref);
                const variantMetaobject =
                    (ref && typeof ref === 'object' ? ref : null) ||
                    indexes.upholsteryVariantIndex.get(variantKey) ||
                    indexes.upholsteryVariantIndex.get(toHandleKey(ref));
                const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
                if (!fabric) return;

                includes.push(fabric.Upholstery_Variant);
                if (!uniqueVariants.has(fabric.Upholstery_Variant.toLowerCase())) {
                    uniqueVariants.add(fabric.Upholstery_Variant.toLowerCase());
                    groupData.push(fabric);
                }
            });

            if (includes.length > 0) {
                groups[optionLabel] = { includes };
            }
        });

        if (Object.keys(groups).length > 0) {
            return {
                groupData,
                categoryData: {
                    [productVendor]: {
                        products: {
                            all_products: {
                                groups
                            }
                        }
                    }
                }
            };
        }

        // Fallback: previous loose matching logic
        productSetList.forEach(item => {
            const rawPattern = normalizeString(getMetaobjectField(item, 'handle_pattern'));
            const groupName = normalizeString(getMetaobjectField(item, 'group_name'));
            if (!rawPattern || !groupName) return;

            const patternList = rawPattern.split(',').map(v => normalizeString(v)).filter(Boolean);
            const fromMetafieldPatterns = (configData.patterns || []).map(v => normalizeString(v)).filter(Boolean);
            const patternsToMatch = fromMetafieldPatterns.length > 0 ? fromMetafieldPatterns : patternList;

            const isMatch = patternsToMatch.some(pattern => pattern && productHandle.includes(pattern));
            if (!isMatch) return;

            const variantRefs = parsePossibleJsonArray(getMetaobjectField(item, 'variants'));
            const includes = [];

            variantRefs.forEach(ref => {
                const variantMetaobject =
                    (ref && typeof ref === 'object' ? ref : null) ||
                    indexes.upholsteryVariantIndex.get(normalizeLower(ref)) ||
                    indexes.upholsteryVariantIndex.get(toHandleKey(ref));
                const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
                if (!fabric) return;

                includes.push(fabric.Upholstery_Variant);

                if (!uniqueVariants.has(fabric.Upholstery_Variant.toLowerCase())) {
                    uniqueVariants.add(fabric.Upholstery_Variant.toLowerCase());
                    groupData.push(fabric);
                }
            });

            if (includes.length > 0) {
                groups[groupName] = { includes };
            }
        });

        return {
            groupData,
            categoryData: {
                [productVendor]: {
                    products: {
                        all_products: {
                            groups
                        }
                    }
                }
            }
        };
    }

    function buildMetaobjectDataForUpholsteryVariants(indexes, optionValues) {
        const groupData = [];
        const seen = new Set();
        (optionValues || []).forEach(value => {
            const normalizedValue = normalizeLower(value);
            const handleValue = toHandleKey(value);
            const variantMetaobject =
                indexes.upholsteryVariantIndex.get(normalizedValue) ||
                indexes.upholsteryVariantIndex.get(handleValue);
            const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
            if (!fabric) return;
            const key = fabric.Upholstery_Variant.toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);
            groupData.push(fabric);
        });
        return groupData;
    }

    function findSwatchMetaobjectByOption(optionValue, swatchIndex) {
        const normalized = normalizeLower(optionValue)
            .replace(/\*/g, '')
            .replace(/\(qs\)/g, '')
            .trim();
        if (!normalized) return null;

        return swatchIndex.get(normalized) || null;
    }

    function createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject) {
        const swatchWrapper = createDirectSwatch(option, originalValue);
        if (!swatchWrapper || !swatchMetaobject) return swatchWrapper;

        const label = swatchWrapper.querySelector('.swatches__form--label');
        if (!label) return swatchWrapper;

        const swatchUrl = normalizeString(getMetaobjectField(swatchMetaobject, 'url'));
        if (swatchUrl) {
            label.dataset.lazyImage = swatchUrl;
        }
        return swatchWrapper;
    }

    // Load JSON data and start the cascade processing
    async function loadData() {
        // Show loading indicator immediately
        showLoadingIndicator();
        setSecondaryCustomSwatchMode(false);
        
        // Get basic parameters
        const variants = safeJsonParse(jsonLoader.dataset.productVariants, []);
        
        try {
            let groupData = null;
            let categoryData = null;
            const productHandle = jsonLoader.dataset.productHandle;
            const productVendor = jsonLoader.dataset.productVendor;
            const optionTitle = jsonLoader.dataset.optionTitle || jsonLoader.dataset.optionName;
            const upholsteryType = safeJsonParse(jsonLoader.dataset.upholsteryType, []);
            const handlePattern = safeJsonParse(jsonLoader.dataset.handlePattern, []);
            const sourceConfig = resolveUpholsterySourceConfig(optionTitle, upholsteryType, handlePattern);

            if (!sourceConfig.sourceType || sourceConfig.sourceType === 'none') {
                hideLoadingIndicator();
                setSecondaryCustomSwatchMode(false);
                return;
            }

            const swatchMetaobjects = safeJsonParse(jsonLoader.dataset.swatchMetaobjects, []);
            const upholsteryVariantMetaobjects = safeJsonParse(jsonLoader.dataset.upholsteryVariantMetaobjects, []);
            const productSetMetaobjects = safeJsonParse(jsonLoader.dataset.productSetMetaobjects, []);
            const indexes = buildMetaobjectIndexes(swatchMetaobjects, upholsteryVariantMetaobjects);

            if (sourceConfig.sourceType === 'group-variants') {
                const metaobjectData = buildMetaobjectDataForGroupVariants(sourceConfig, productSetMetaobjects, indexes, productHandle, productVendor, variants);
                console.log('metaobjectDatametaobjectData', metaobjectData);
                groupData = metaobjectData.groupData;
                categoryData = metaobjectData.categoryData;
            } else if (sourceConfig.sourceType === 'upholstery-variants') {
                groupData = buildMetaobjectDataForUpholsteryVariants(indexes, variants);
                categoryData = null;
            } else if (sourceConfig.sourceType === 'swatch' || sourceConfig.sourceType === 'swatches') {
                if (tryProcessAsDirect(variants)) {
                    return;
                }
                hideLoadingIndicator();
                setSecondaryCustomSwatchMode(false);
                return;
            } else {
                hideLoadingIndicator();
                setSecondaryCustomSwatchMode(false);
                return;
            }

            if (!groupData || groupData.length === 0) {
                hideLoadingIndicator();
                setSecondaryCustomSwatchMode(false);
                return;
            }
            
            // Process the data through the cascade
            await processDataCascade(groupData, categoryData, variants, productVendor, productHandle);
            
        } catch (error) {
            // Hide loading indicator on error
            hideLoadingIndicator();
            setSecondaryCustomSwatchMode(false);
            
            // Show error message
            const errorDiv = document.createElement('div');
            errorDiv.className = 'fabric-error';
            errorDiv.textContent = 'Unable to load secondary upholstery variant options. Please try refreshing the page.';
            jsonLoader.parentNode.insertBefore(errorDiv, jsonLoader);
        }
    }
    
    // Track which strategy is used to process fabrics
    let currentProcessingStrategy = '';
    
    // New cascade processing function that tries different approaches in sequence
    async function processDataCascade(groupData, categoryData, variants, productVendor, productHandle) {
        let processSuccess = false;
        
        // Initialize the image observer before processing
        initializeImageObserver();
        
        // STRATEGY 1: Try processing as Upholstery Group first
        if (categoryData) {
            processSuccess = await tryProcessAsUpholsteryGroup(groupData, categoryData, variants, productVendor, productHandle);
        }
        
        // STRATEGY 2: If no success, try processing as general Upholstery
        if (!processSuccess) {
            processSuccess = tryProcessAsUpholstery(groupData, variants);
        }
        
        // STRATEGY 3: If still no success, fall back to direct matching
        if (!processSuccess) {
            // Hide loading indicator if all strategies fail
            hideLoadingIndicator();
            setSecondaryCustomSwatchMode(false);
        }
    }

    // Handle metafield JSON format: { "<OptionName>": { "Swatches": [...] } }
    function tryProcessSimpleOptionSwatches(groupData, variants) {
        currentProcessingStrategy = 'simpleOptionSwatches';

        if (!groupData || typeof groupData !== 'object' || Array.isArray(groupData)) {
            return false;
        }

        const optionName = (jsonLoader.dataset.optionName || '').trim();
        if (!optionName) return false;

        let matchedKey = Object.keys(groupData).find(
            key => (key || '').trim().toLowerCase() === optionName.toLowerCase()
        );

        // Fallback: if metafield only has one top-level key, use it
        if (!matchedKey && Object.keys(groupData).length === 1) {
            matchedKey = Object.keys(groupData)[0];
        }

        if (!matchedKey) return false;

        const optionEntry = groupData[matchedKey];
        if (!optionEntry || !Array.isArray(optionEntry.Swatches) || optionEntry.Swatches.length === 0) {
            return false;
        }

        const variantValues = new Set(
            (variants || [])
                .map(v => (v || '').replace('*', '').replace('(QS)', '').trim().toLowerCase())
                .filter(Boolean)
        );

        const normalizedSwatches = optionEntry.Swatches
            .map(swatch => {
                const value = (swatch.Web_Name || swatch.Swatch_Name || '').trim();
                return {
                    value,
                    image: swatch.Link_Handle || ''
                };
            })
            .filter(s => s.value)
            .filter(s => variantValues.size === 0 || variantValues.has(s.value.toLowerCase()));

        if (normalizedSwatches.length === 0) return false;

        sliderWrapper.innerHTML = '';
        const slide = document.createElement('div');
        slide.className = 'fabric-slide';

        const title = document.createElement('h4');
        title.className = 'section-title';
        title.textContent = optionName;
        slide.appendChild(title);

        const swatchGroup = document.createElement('div');
        swatchGroup.className = 'swatches__form--group';
        swatchGroup.dataset.fabricType = optionName;
        slide.appendChild(swatchGroup);

        const swatchesContainer = document.createElement('div');
        swatchesContainer.className = 'swatches__form--wrapper-container';
        swatchGroup.appendChild(swatchesContainer);

        normalizedSwatches.forEach(swatch => {
            const imageUrl = swatch.image.startsWith('/')
                ? `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${swatch.image}`
                : swatch.image;

            const safeId = swatch.value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
            const swatchWrapper = document.createElement('div');
            swatchWrapper.className = 'swatches__form--wrapper';

            swatchWrapper.innerHTML = `
                <label class="swatches__form--label"
                      for="swatch-${safeId}"
                      tabindex="0"
                      data-lazy-image="${imageUrl}"
                      data-swatch-code="${swatch.value}"
                      data-fabric-type="${optionName}"
                      data-original-value="${swatch.value}"
                      data-swatch-name="${optionName}"
                      data-display-name="${optionName}"
                      data-option-name="${optionName}">
                </label>
                <span class="swatches__form--name">${swatch.value}</span>
            `;

            swatchesContainer.appendChild(swatchWrapper);
        });

        sliderWrapper.appendChild(slide);
        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, 1);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();

        return true;
    }

    // Handle metafield JSON format:
    // { "<OptionName>": { "<CategoryName>": [ { Upholstery_Variant, Swatches: [...] } ] } }
    function tryProcessNestedOptionGroups(groupData, variants) {
        currentProcessingStrategy = 'nestedOptionGroups';

        if (!groupData || typeof groupData !== 'object' || Array.isArray(groupData)) {
            return false;
        }

        const optionName = (jsonLoader.dataset.optionName || '').trim();
        if (!optionName) return false;

        let matchedKey = Object.keys(groupData).find(
            key => (key || '').trim().toLowerCase() === optionName.toLowerCase()
        );
        // Fallback: if metafield only has one top-level key, use it
        if (!matchedKey && Object.keys(groupData).length === 1) {
            matchedKey = Object.keys(groupData)[0];
        }
        if (!matchedKey) return false;

        const optionEntry = groupData[matchedKey];
        if (!optionEntry || typeof optionEntry !== 'object' || Array.isArray(optionEntry) || Array.isArray(optionEntry.Swatches)) {
            return false;
        }

        sliderWrapper.innerHTML = '';
        let slideCount = 0;

        Object.entries(optionEntry).forEach(([categoryName, fabrics]) => {
            if (!Array.isArray(fabrics) || fabrics.length === 0) return;
            fabrics.forEach(fabric => {
                if (!fabric || !Array.isArray(fabric.Swatches) || fabric.Swatches.length === 0) return;

                const slide = document.createElement('div');
                slide.className = 'fabric-slide';

                const fabricGroup = createFabricGroup(
                    fabric,
                    fabric.Upholstery_Variant || fabric.Display_Name || categoryName,
                    categoryName
                );
                if (fabricGroup) {
                    slide.appendChild(fabricGroup);
                    sliderWrapper.appendChild(slide);
                    slideCount++;
                }
            });
        });

        if (slideCount === 0) return false;

        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();

        return true;
    }
    
    // Process as Upholstery Group (with category data)
    async function tryProcessAsUpholsteryGroup(groupData, categoryData, variants, productVendor, productHandle) {
        // Set the strategy flag
        currentProcessingStrategy = 'upholsteryGroup';
        
        // Find applicable groups
        const { applicableGroups, isSpecificMatch } = findApplicableGroups(categoryData, productVendor, productHandle);
        
        // Filter fabric groups by applicable groups
        const filteredGroups = filterFabricGroups(groupData, applicableGroups);
        
        // If we don't have any applicable groups, fail this strategy
        if (Object.keys(applicableGroups).length === 0 || filteredGroups.length === 0) {
            return false;
        }
        
        // Process as upholstery group
        let slideCount = createSlidesForUpholsteryGroup(filteredGroups, variants, sliderWrapper);
        
        // If we didn't create any slides, fail this strategy
        if (slideCount === 0) {
            return false;
        }
        
        // Show container and initialize
        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, slideCount);
        
        // Add event listeners
        attachSwatchListeners();
        observeSwatches();
        
        // Select the first swatch to show preview on load
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }
    
    // Process as general Upholstery (direct lookup in groupData)
    function tryProcessAsUpholstery(groupData, variants) {
        // Set the strategy flag
        currentProcessingStrategy = 'upholstery';
        
        // Process variants into categories
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        // Track if we have any matched fabrics
        let hasAnyMatch = false;
        const matchedFeatured = [];
        const matchedQuickShip = [];
        const matchedRegular = [];
        
        // Check featured fabrics
        for (let i = 0; i < featured.options.length; i++) {
            const option = featured.options[i];
            const matchingFabric = findFabricByName(option, groupData);
            if (matchingFabric) {
                hasAnyMatch = true;
                matchedFeatured.push(i);
            }
        }
        
        // Check quick ship fabrics
        for (let i = 0; i < quickShip.options.length; i++) {
            const option = quickShip.options[i];
            const matchingFabric = findFabricByName(option, groupData);
            if (matchingFabric) {
                hasAnyMatch = true;
                matchedQuickShip.push(i);
            }
        }
        
        // Check regular fabrics
        for (let i = 0; i < regular.options.length; i++) {
            const option = regular.options[i];
            const matchingFabric = findFabricByName(option, groupData);
            if (matchingFabric) {
                hasAnyMatch = true;
                matchedRegular.push(i);
            }
        }
        
        // If no matching fabrics found, fail this strategy
        if (!hasAnyMatch) {
            return false;
        }
        
        // We have matches, so create separate slides
        const slideElements = {
            featured: [],
            quickShip: [],
            regular: []
        };

        // Create Featured slides
        if (featured.options.length > 0) {
            let hasFeaturedContent = false;
            const featuredSlide = document.createElement('div');
            featuredSlide.className = 'fabric-slide';
            
            const titleElement = document.createElement('h4');
            titleElement.className = 'section-title';
            titleElement.textContent = 'Featured';
            featuredSlide.appendChild(titleElement);
            
            // Add only matched featured fabrics
            if (matchedFeatured.length > 0) {
                matchedFeatured.forEach(index => {
                    const option = featured.options[index];
                    const originalValue = featured.originals[index];
                    
                    const matchingFabric = findFabricByName(option, groupData);
                    if (matchingFabric) {
                        const fabricGroup = createFabricGroup(matchingFabric, originalValue);
                        if (fabricGroup) {
                            featuredSlide.appendChild(fabricGroup);
                            hasFeaturedContent = true;
                        }
                    }
                });
            }
            
            // Add non-matched featured fabrics as direct swatches
            featured.options.forEach((option, i) => {
                if (!matchedFeatured.includes(i)) {
                    const originalValue = featured.originals[i];
                    const swatchEl = createDirectSwatch(option, originalValue);
                    featuredSlide.appendChild(swatchEl);
                    hasFeaturedContent = true;
                }
            });
            
            if (hasFeaturedContent) {
                slideElements.featured.push(featuredSlide);
            }
        }
        
        // Create Quick Ship slides
        if (quickShip.options.length > 0) {
            let hasQuickShipContent = false;
            const quickShipSlide = document.createElement('div');
            quickShipSlide.className = 'fabric-slide';
            
            const titleElement = document.createElement('h4');
            titleElement.className = 'section-title';
            titleElement.textContent = 'Quick Ship';
            quickShipSlide.appendChild(titleElement);
            
            // Add only matched quick ship fabrics
            if (matchedQuickShip.length > 0) {
                matchedQuickShip.forEach(index => {
                    const option = quickShip.options[index];
                    const originalValue = quickShip.originals[index];
                    
                    const matchingFabric = findFabricByName(option, groupData);
                    if (matchingFabric) {
                        const fabricGroup = createFabricGroup(matchingFabric, originalValue);
                        if (fabricGroup) {
                            quickShipSlide.appendChild(fabricGroup);
                            hasQuickShipContent = true;
                        }
                    }
                });
            }
            
            // Add non-matched quick ship fabrics as direct swatches
            quickShip.options.forEach((option, i) => {
                if (!matchedQuickShip.includes(i)) {
                    const originalValue = quickShip.originals[i];
                    const swatchEl = createDirectSwatch(option, originalValue);
                    quickShipSlide.appendChild(swatchEl);
                    hasQuickShipContent = true;
                }
            });
            
            if (hasQuickShipContent) {
                slideElements.quickShip.push(quickShipSlide);
            }
        }
        
        // Create regular slides
        if (regular.options.length > 0) {
            // First add all matched regular fabrics on their own slides
            if (matchedRegular.length > 0) {
                matchedRegular.forEach(index => {
                    const option = regular.options[index];
                    
                    const regularSlide = document.createElement('div');
                    regularSlide.className = 'fabric-slide';
                    
                    const matchingFabric = findFabricByName(option, groupData);
                    
                    if (matchingFabric) {
                        const fabricGroup = createFabricGroup(matchingFabric, option);
                        if (fabricGroup) {
                            regularSlide.appendChild(fabricGroup);
                            slideElements.regular.push(regularSlide);
                        }
                    }
                });
            }
            
            // Now add any non-matched regular options on a separate slide
            const nonMatchedIndices = [];
            for (let i = 0; i < regular.options.length; i++) {
                if (!matchedRegular.includes(i)) {
                    nonMatchedIndices.push(i);
                }
            }
            
            if (nonMatchedIndices.length > 0) {
                const regularNonMatchedSlide = document.createElement('div');
                regularNonMatchedSlide.className = 'fabric-slide';
                
                const titleElement = document.createElement('h4');
                titleElement.className = 'section-title';
                titleElement.textContent = jsonLoader.dataset.optionTitle || 'Options';
                regularNonMatchedSlide.appendChild(titleElement);
                
                nonMatchedIndices.forEach(i => {
                    const option = regular.options[i];
                    const swatchEl = createDirectSwatch(option, option);
                    regularNonMatchedSlide.appendChild(swatchEl);
                });
                
                slideElements.regular.push(regularNonMatchedSlide);
            }
        }
        
        let slideCount = slideElements.featured.length + slideElements.quickShip.length + slideElements.regular.length;
        
        // If no slides were created, fail this strategy
        if (slideCount === 0) {
            return false;
        }
        
        // Now add all slides in the correct order
        [...slideElements.featured, ...slideElements.quickShip, ...slideElements.regular].forEach(slide => {
            sliderWrapper.appendChild(slide);
        });
        
        // Show container and initialize
        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, slideCount);
        
        // Add event listeners
        attachSwatchListeners();
        observeSwatches();
        
        // Select the first swatch to show preview on load
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }
    
    // Process as direct (fallback strategy)
    function tryProcessAsDirect(variants) {
        // Set the strategy flag
        currentProcessingStrategy = 'direct';
        
        // Create direct matching slides
        const slideCount = createDirectMatchSlides(variants, sliderWrapper);
        
        // If no slides were created, return false
        if (slideCount === 0) {
            return false;
        }
        
        // Show container and initialize
        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, slideCount);
        
        // Add event listeners
        attachSwatchListeners();
        observeSwatches();
        
        // Select the first swatch to show preview on load
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }

    function tryProcessAsDirectMetaobjectSwatch(variants, swatchIndex) {
        currentProcessingStrategy = 'direct';

        const slideCount = createDirectMatchSlides(variants, sliderWrapper, swatchIndex);
        if (slideCount === 0) return false;

        sliderContainer.style.display = 'block';
        setSecondaryCustomSwatchMode(true);
        initializeSlider(sliderContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();
        return true;
    }
    
    // Observe swatches for lazy loading
    function observeSwatches() {
        if (!imageObserver) return;
        
        // Find all swatches with lazy loading data in secondary container
        const swatches = document.querySelectorAll('#swatch-container-1 .swatches__form--label[data-lazy-image]');
        swatches.forEach(swatch => {
            // Direct swatches should load immediately so users don't see blank tiles
            if (swatch.classList.contains('direct-swatch') && !swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                loadSwatchImage(swatch);
                return;
            }
            imageObserver.observe(swatch);
        });
    }

    // Find applicable fabric groups for the product based on vendor and handle
    function findApplicableGroups(categoryData, productVendor, productHandle) {
        // Default to empty groups
        let applicableGroups = {};
        let isSpecificMatch = false;
        
        // Check if vendor exists in data
        const vendorData = categoryData[productVendor];
        if (!vendorData || !vendorData.products) {
            return { applicableGroups, isSpecificMatch };
        }
        
        // First check for specific product matches
        const products = vendorData.products;
        
        // Loop through product patterns
        for (const handlePattern in products) {
            // Skip all_products and "all products" for now
            if (handlePattern === 'all_products' || handlePattern === 'all products') continue;
            
            // Check if any pattern matches the current product handle
            const patterns = handlePattern.split(',').map(p => p.trim());
            if (patterns.some(pattern => productHandle.includes(pattern))) {
                // We found a match!
                applicableGroups = products[handlePattern].groups || {};
                isSpecificMatch = true;
                break;
            }
        }
        
        // If no specific match, use all_products or "all products" if available
        if (!isSpecificMatch) {
            if (products.all_products) {
                applicableGroups = products.all_products.groups || {};
            } else if (products['all products']) {
                applicableGroups = products['all products'].groups || {};
            }
        }
        
        return { applicableGroups, isSpecificMatch };
    }
    
    // Filter fabric groups based on applicable groups
    function filterFabricGroups(groupData, applicableGroups) {
        const result = [];
        
        // For each category and its included fabrics
        for (const categoryName in applicableGroups) {
            const includes = applicableGroups[categoryName].includes || [];
            
            // For each included fabric, find its details in groupData
            includes.forEach(fabricId => {
                // Find matching fabric group
                const fabricGroup = groupData.find(group => 
                    group.Upholstery_Variant === fabricId
                );
                
                if (fabricGroup) {
                    // Add category information to the fabric group
                    result.push({
                        ...fabricGroup,
                        categoryName: categoryName // Store the category name
                    });
                }
            });
        }
        
        return result;
    }
    
    // New function for direct matching slides - creating separate slides for Featured/QuickShip
    function createDirectMatchSlides(variants, sliderWrapper, swatchIndex) {
        // Process variants into categories
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        let slideCount = 0;
        
        // Create separate slides for each category
        
        // Add Featured slide if applicable
        if (featured.options.length > 0) {
            const featuredSlide = document.createElement('div');
            featuredSlide.className = 'fabric-slide';
            
            const featuredTitle = document.createElement('h4');
            featuredTitle.className = 'section-title';
            featuredTitle.textContent = 'Featured';
            featuredSlide.appendChild(featuredTitle);
            
            let hasContent = false;
            
            // Add fabrics for each featured option
            for (let i = 0; i < featured.options.length; i++) {
                const option = featured.options[i];
                const originalValue = featured.originals[i];
                
                // Create direct swatch
                const swatchMetaobject = swatchIndex ? findSwatchMetaobjectByOption(option, swatchIndex) : null;
                const swatchEl = swatchMetaobject
                    ? createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject)
                    : createDirectSwatch(option, originalValue);
                featuredSlide.appendChild(swatchEl);
                hasContent = true;
            }
            
            if (hasContent) {
                sliderWrapper.appendChild(featuredSlide);
                slideCount++;
            }
        }
        
        // Add Quick Ship slide if applicable
        if (quickShip.options.length > 0) {
            const quickShipSlide = document.createElement('div');
            quickShipSlide.className = 'fabric-slide';
            
            const quickShipTitle = document.createElement('h4');
            quickShipTitle.className = 'section-title';
            quickShipTitle.textContent = 'Quick Ship';
            quickShipSlide.appendChild(quickShipTitle);
            
            let hasContent = false;
            
            // Add fabrics for each quick ship option
            for (let i = 0; i < quickShip.options.length; i++) {
                const option = quickShip.options[i];
                const originalValue = quickShip.originals[i];
                
                // Create direct swatch
                const swatchMetaobject = swatchIndex ? findSwatchMetaobjectByOption(option, swatchIndex) : null;
                const swatchEl = swatchMetaobject
                    ? createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject)
                    : createDirectSwatch(option, originalValue);
                quickShipSlide.appendChild(swatchEl);
                hasContent = true;
            }
            
            if (hasContent) {
                sliderWrapper.appendChild(quickShipSlide);
                slideCount++;
            }
        }
        
        // Add Regular section if applicable
        if (regular.options.length > 0) {
            const regularSlide = document.createElement('div');
            regularSlide.className = 'fabric-slide';
            
            const optionTitle = jsonLoader.dataset.optionTitle || 'Options';
            const regularTitle = document.createElement('h4');
            regularTitle.className = 'section-title';
            regularTitle.textContent = optionTitle;
            regularSlide.appendChild(regularTitle);
            
            let hasContent = false;
            
            // Add all regular fabrics
            for (let i = 0; i < regular.options.length; i++) {
                const option = regular.options[i];
                
                // Create direct swatch
                const swatchMetaobject = swatchIndex ? findSwatchMetaobjectByOption(option, swatchIndex) : null;
                const swatchEl = swatchMetaobject
                    ? createDirectSwatchFromMetaobject(option, option, swatchMetaobject)
                    : createDirectSwatch(option, option);
                regularSlide.appendChild(swatchEl);
                hasContent = true;
            }
            
            if (hasContent) {
                sliderWrapper.appendChild(regularSlide);
                slideCount++;
            }
        }
        
        return slideCount;
    }
    
    // Sort variants into featured, quick ship, and regular
    function categorizeVariants(variants) {
        const featured = { options: [], originals: [] };
        const quickShip = { options: [], originals: [] };
        const regular = { options: [], originals: [] };
        
        variants.forEach(value => {
            if (value.includes('*')) {
                const cleanValue = value.replace('*', '').trim();
                featured.options.push(cleanValue);
                featured.originals.push(value);
            } else if (value.includes('(QS)')) {
                const cleanValue = value.replace('(QS)', '').trim();
                quickShip.options.push(cleanValue);
                quickShip.originals.push(value);
            } else {
                regular.options.push(value);
                regular.originals.push(value);
            }
        });
        
        return { featured, quickShip, regular };
    }
    
    // Create slides for Upholstery Group option
    function createSlidesForUpholsteryGroup(filteredGroups, variants, sliderWrapper) {
        // Check if we have any relevant fabric groups
        if (!filteredGroups || filteredGroups.length === 0) {
            return 0;
        }
        
        // Process variants into categories
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        let slideCount = 0;
        
        // Store slides for proper ordering later
        const slideElements = {
            featured: [],
            quickShip: [],
            regular: []
        };
        
        // Group fabrics by categoryName rather than by Display_Name
        const groupedByFabricGroup = {};
        filteredGroups.forEach(fabric => {
            const groupName = fabric.categoryName;
            if (!groupName) return;
            
            if (!groupedByFabricGroup[groupName]) {
                groupedByFabricGroup[groupName] = [];
            }
            groupedByFabricGroup[groupName].push(fabric);
        });
        
        // Sort the groups to ensure Featured -> Quick Ship -> Regular order
        const sortedFabricGroups = [];
        
        // Track which variants have matches in the JSON
        const matchedFeatured = [];
        const matchedQuickShip = [];
        const matchedRegular = [];
        
        // First add all Featured fabric groups
        featured.options.forEach((option, index) => {
            const cleanOption = option.replace('*', '').trim();
            
            // Only exact category matches (e.g., "CAT 1")
            const matchingGroups = Object.keys(groupedByFabricGroup).filter(groupName => 
                groupName === cleanOption
            );
            
            if (matchingGroups.length > 0) {
                matchedFeatured.push(index);
                matchingGroups.forEach(group => {
                    if (!sortedFabricGroups.some(g => g.name === group)) {
                        sortedFabricGroups.push({
                            name: group,
                            isFeatured: true,
                            isQuickShip: false
                        });
                    }
                });
            }
        });
        
        // Then add all Quick Ship fabric groups
        quickShip.options.forEach((option, index) => {
            const cleanOption = option.replace('(QS)', '').trim();
            
            // Only exact category matches (e.g., "CAT 2")
            const matchingGroups = Object.keys(groupedByFabricGroup).filter(groupName => 
                groupName === cleanOption
            );
            
            if (matchingGroups.length > 0) {
                matchedQuickShip.push(index);
                matchingGroups.forEach(group => {
                    // Only add if not already added as featured
                    if (!sortedFabricGroups.some(g => g.name === group)) {
                        sortedFabricGroups.push({
                            name: group,
                            isFeatured: false,
                            isQuickShip: true
                        });
                    }
                });
            }
        });
        
        // Match regular options
        regular.options.forEach((option, index) => {
            // Only exact category matches (e.g., "CAT 3")
            const matchingGroups = Object.keys(groupedByFabricGroup).filter(groupName => 
                groupName === option.trim()
            );
            
            if (matchingGroups.length > 0) {
                matchedRegular.push(index);
                matchingGroups.forEach(group => {
                    // Only add if not already added as featured or quick ship
                    if (!sortedFabricGroups.some(g => g.name === group)) {
                        sortedFabricGroups.push({
                            name: group,
                            isFeatured: false,
                            isQuickShip: false
                        });
                    }
                });
            }
        });
        
        // Create separate slides for each fabric rather than grouping by category
        filteredGroups.forEach(fabric => {
            // Skip fabrics without Display_Name or Swatches
            if (!fabric.Display_Name || !fabric.Swatches || fabric.Swatches.length === 0) {
                return;
            }
            
            // Determine if this fabric belongs to a matched category
            const categoryMatched = sortedFabricGroups.some(group => group.name === fabric.categoryName);
            if (!categoryMatched) {
                return; // Skip fabrics from unmatched categories
            }
            
            // Determine if this is featured or quick ship
            const isFeatured = sortedFabricGroups.find(group => 
                group.name === fabric.categoryName && group.isFeatured
            ) != null;
            
            const isQuickShip = sortedFabricGroups.find(group => 
                group.name === fabric.categoryName && group.isQuickShip
            ) != null;
            
            // Create a new slide for this fabric
            const slide = document.createElement('div');
            slide.className = 'fabric-slide';
            
            // Add any badge if needed
            if (isFeatured || isQuickShip) {
                const badgeSpan = document.createElement('span');
                badgeSpan.className = isFeatured ? 'featured-badge' : 'quick-ship-badge';
                badgeSpan.textContent = isFeatured ? 'Featured' : 'Quick Ship';
                slide.appendChild(badgeSpan);
            }
            
            // Create a fabric group for this fabric
            const fabricGroup = createFabricGroup(fabric, fabric.Upholstery_Variant, fabric.categoryName);
            if (fabricGroup) {
                slide.appendChild(fabricGroup);
                
                // Add the slide to the appropriate category
                if (isFeatured) {
                    slideElements.featured.push(slide);
                } else if (isQuickShip) {
                    slideElements.quickShip.push(slide);
                } else {
                    slideElements.regular.push(slide);
                }
                slideCount++;
            }
        });
        
        // Create a special slide for non-matching featured and quick ship variants
        const nonMatchingVariants = [];
        
        // Check for non-matching featured variants
        featured.options.forEach((option, index) => {
            if (!matchedFeatured.includes(index)) {
                const cleanOption = option.replace(/\*/g, '').trim();
                nonMatchingVariants.push({
                    option: cleanOption,
                    originalValue: featured.originals[index],
                    isFeatured: true
                });
            }
        });
        
        // Check for non-matching quick ship variants
        quickShip.options.forEach((option, index) => {
            if (!matchedQuickShip.includes(index)) {
                const cleanOption = option.replace(/\(QS\)/g, '').trim();
                nonMatchingVariants.push({
                    option: cleanOption,
                    originalValue: quickShip.originals[index],
                    isQuickShip: true
                });
            }
        });
        
        // If we have any non-matching featured or quick ship variants, create slides for them
        if (nonMatchingVariants.length > 0) {
            // Group by type
            const featuredNonMatching = nonMatchingVariants.filter(v => v.isFeatured);
            const quickShipNonMatching = nonMatchingVariants.filter(v => v.isQuickShip);
            
            // Create featured non-matching slide
            if (featuredNonMatching.length > 0) {
                const featuredNonMatchingSlide = document.createElement('div');
                featuredNonMatchingSlide.className = 'fabric-slide';
                
                const featuredSection = document.createElement('div');
                featuredSection.className = 'section-container';
                
                const featuredTitle = document.createElement('h4');
                featuredTitle.className = 'section-title';
                featuredTitle.textContent = 'Featured';
                featuredSection.appendChild(featuredTitle);
                
                featuredNonMatching.forEach(variant => {
                    const swatchEl = createDirectSwatch(variant.option, variant.originalValue);
                    featuredSection.appendChild(swatchEl);
                });
                
                featuredNonMatchingSlide.appendChild(featuredSection);
                slideElements.featured.push(featuredNonMatchingSlide);
                slideCount++;
            }
            
            // Create quick ship non-matching slide
            if (quickShipNonMatching.length > 0) {
                const quickShipNonMatchingSlide = document.createElement('div');
                quickShipNonMatchingSlide.className = 'fabric-slide';
                
                const quickShipSection = document.createElement('div');
                quickShipSection.className = 'section-container';
                
                const quickShipTitle = document.createElement('h4');
                quickShipTitle.className = 'section-title';
                quickShipTitle.textContent = 'Quick Ship';
                quickShipSection.appendChild(quickShipTitle);
                
                quickShipNonMatching.forEach(variant => {
                    const swatchEl = createDirectSwatch(variant.option, variant.originalValue);
                    quickShipSection.appendChild(swatchEl);
                });
                
                quickShipNonMatchingSlide.appendChild(quickShipSection);
                slideElements.quickShip.push(quickShipNonMatchingSlide);
                slideCount++;
            }
        }
        
        // Add all slides to the wrapper in correct order: Featured -> Quick Ship -> Regular
        [...slideElements.featured, ...slideElements.quickShip, ...slideElements.regular].forEach(slide => {
            sliderWrapper.appendChild(slide);
        });
        
        return slideCount;
    }

    // Find fabric group by name
    function findFabricByName(name, fabricGroups) {
        const nameLower = name.toLowerCase();
        return fabricGroups.find(fabric => 
            fabric.Upholstery_Variant && 
            fabric.Upholstery_Variant.toLowerCase() === nameLower && 
            fabric.Swatches && 
            fabric.Swatches.length > 0
        );
    }

    // Helper function to decode HTML entities
    function decodeHTMLEntities(text) {
        if (!text) return '';
        
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    
// Create a fabric group element with lazy loading
function createFabricGroup(fabric, originalValue, categoryName) {
    if (!fabric.Swatches || fabric.Swatches.length === 0) return null;
    const swatchDiv = document.getElementById('json-loader-1');

    // Get the value of a specific attribute, for example, a data attribute
    const optName = swatchDiv ? swatchDiv.getAttribute('data-option-name') : null;
    const fabricGroup = document.createElement('div');
    fabricGroup.className = 'swatches__form--group';
    fabricGroup.dataset.fabricType = fabric.Upholstery_Variant;
    
    // Add title
    const titleElement = document.createElement('h4');
    titleElement.className = 'swatches__form--title';
    titleElement.textContent = fabric.Display_Name;
    fabricGroup.appendChild(titleElement);
    
    // Add fabric information when available
    const infoContainer = document.createElement('div');
    infoContainer.className = 'fabric-info-container';
    
    // Add composition if available
    if (fabric.Composition) {
        const compositionElement = document.createElement('div');
        compositionElement.className = 'group_composition';
        compositionElement.textContent = `${decodeHTMLEntities(fabric.Composition)}`;
        infoContainer.appendChild(compositionElement);
    }
    
    // Add durability if available
    if (fabric.Durability) {
        const durabilityElement = document.createElement('div');
        durabilityElement.className = 'group_durability';
        durabilityElement.textContent = `${decodeHTMLEntities(fabric.Durability)}`;
        infoContainer.appendChild(durabilityElement);
    }
    
    // Add designer if available
    if (fabric.Designer) {
        const designerElement = document.createElement('div');
        designerElement.className = 'group_designer';
        designerElement.textContent = `${decodeHTMLEntities(fabric.Designer)}`;
        infoContainer.appendChild(designerElement);
    }
    
    // Add notes if available
    if (fabric.Notes) {
        const notesElement = document.createElement('div');
        notesElement.className = 'group_notes';
        notesElement.textContent = `${decodeHTMLEntities(fabric.Notes)}`;
        infoContainer.appendChild(notesElement);
    }
    
    // Only append the container if it has any children
    if (infoContainer.children.length > 0) {
        fabricGroup.appendChild(infoContainer);
    }
    
    // Create a container for swatches
    const swatchesContainer = document.createElement('div');
    swatchesContainer.className = 'swatches__form--wrapper-container';
    fabricGroup.appendChild(swatchesContainer);
    
    // Add swatches to the container with lazy loading
    fabric.Swatches.forEach(swatch => {
        // Construct image URL
        const imageUrl = swatch.Link_Handle.startsWith('/') ?
            `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${swatch.Link_Handle}` :
            swatch.Link_Handle;
        
        const swatchWrapper = document.createElement('div');
        swatchWrapper.className = 'swatches__form--wrapper';
        
        swatchWrapper.innerHTML = `
            <label class="swatches__form--label"
                  for="swatch-${fabric.Upholstery_Variant.toLowerCase().replace(/\s+/g, '-')}-${swatch.Web_Name}"
                  tabindex="0"
                  data-lazy-image="${imageUrl}"
                  data-swatch-code="${swatch.Web_Name}"
                  data-fabric-type="${fabric.Upholstery_Variant}"
                  ${categoryName ? `data-fabric-group="${categoryName}"` : ''}
                  data-original-value="${originalValue}"
                  data-swatch-name="${fabric.Display_Name}"
                  data-display-name="${fabric.Display_Name}"
                  data-option-name="${optName}">
            </label>
            <span class="swatches__form--name">
              ${swatch.Web_Name}
            </span>
        `;
        
        swatchesContainer.appendChild(swatchWrapper);
    });
    
    return fabricGroup;
}
    
    // Create a direct swatch with lazy loading
    function createDirectSwatch(option, originalValue) {
        // Clean option string for URL construction by removing * and (QS)
        const cleanOption = option.replace(/\*/g, '').replace(/\(QS\)/g, '').trim();
        
        // Improve URL construction to prevent multiple consecutive hyphens
        // First normalize any existing hyphens to spaces
        const normalizedOption = cleanOption.replace(/-/g, ' ');

        // Remove slashes completely
        const noSlashes = normalizedOption.replace(/[\/|]/g, '');

        // Normalize spaces (reducing multiple spaces to a single space)
        const normalizedSpaces = noSlashes.replace(/\s+/g, ' ').trim();
      
        // Then create a clean hyphenated version - also remove parentheses, slashes, and colons
        const f = normalizedSpaces.toLowerCase().replace(/\s+/g, '-').replace(/[\(\):/\\.]|%3A/g, '');
        
        // Construct the URL with the properly formatted string
        const swatchUrl = `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${f}.jpg`;
        
        // Get the fallback variant image if it exists
        const variantImageUrl = window.variantImageMap && window.variantImageMap[f];
        
        const swatchWrapper = document.createElement('div');
        swatchWrapper.className = 'swatches__form--wrapper';
        
        swatchWrapper.innerHTML = `
            <label class="swatches__form--label direct-swatch"
                  for="swatch-${f}"
                  tabindex="0"
                  data-lazy-image="${swatchUrl}"
                  data-swatch-code="${cleanOption}"
                  data-fabric-type="${cleanOption}"
                  data-original-value="${originalValue}"
                  data-variant-fallback="${variantImageUrl || ''}">
            </label>
            <span class="swatches__form--name">${originalValue}</span>
        `;
        
        return swatchWrapper;
    }
    
    // Extract image URL from background-image style
    function extractImageUrl(bgImage) {
        if (bgImage && bgImage !== 'none') {
            return bgImage.slice(5, -2); // Remove url(" and ")
        }
        return '';
    }
    
// Handle swatch click event
function handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const fabricType = swatch.dataset.fabricType;
    const fabricGroup = swatch.dataset.fabricGroup;
    const code = swatch.dataset.swatchCode;
    const originalValue = swatch.dataset.originalValue;
    const displayName = swatch.dataset.displayName;
    
    // For lazy loaded images, ensure image is loaded before using
    if (swatch.dataset.lazyImage && !swatch.classList.contains('loaded')) {
        loadSwatchImage(swatch);
    }
    
    const bgImage = swatch.style.backgroundImage;
    
    // Validate we have required data
    if (!fabricType || !code) return;

    // Determine if this is a direct swatch
    const isDirect = swatch.classList.contains('direct-swatch');
    
    // Find composition if available
    let composition = '';
    const groupElement = swatch.closest('.swatches__form--group') || swatch.closest('.fabric-slide');
    if (groupElement) {
        const compositionElement = groupElement.querySelector('.group_composition');
        if (compositionElement) {
            composition = compositionElement.textContent;
        }
    }
    
    // Extract image URL and clean it
    let imageUrl = extractImageUrl(bgImage);
    if (!imageUrl) {
        // Use the lazy image URL if available
        imageUrl = swatch.dataset.lazyImage || 
            `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${fabricType.toLowerCase().replace(/\s+/g, '-').replace(/[\(\)]/g, '')}.jpg`;
    }
  
    updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName);
    updateSecondaryLineItem(fabricType, code, isDirect, fabricGroup, originalValue);
    
    // Use unified handler for 3D update - secondary fabric is option 2
    handleOptionChange(2, fabricType, swatch);
    
    // Prevent event from bubbling up
    event.stopPropagation();
}
    
// Update preview panel with fallback support
function updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName) {
    // Guard against missing data or elements
    if (!fabricType || !imageUrl || !code || 
        !previewImage || !previewTitle || !previewDescription || !selectedFabricInput) {
        return;
    }
    
    // Get normalized option for variant image lookup
    const normalizedOption = fabricType.toLowerCase().replace(/\s+/g, '-');
    const variantImageUrl = window.variantImageMap && window.variantImageMap[normalizedOption];
    
    // Save the current selection with fallback reference
    lastSelectedFabric = {
        fabricType,
        code,
        imageUrl,
        variantImageUrl,
        composition,
        isDirect,
        displayName
    };
    
    fabricPreview.style.display = 'block';
    
    // Set up image error handling directly on the preview image
    previewImage.onerror = function() {
        if (variantImageUrl) {
            previewImage.src = variantImageUrl;
            previewImage.onerror = function() {
                const finalFallbackUrl = `https://www.danishdesignstore.com/cdn/shop/files/${normalizedOption.replace(/[\(\)]/g, '')}.jpg`;
                previewImage.src = finalFallbackUrl;
                previewImage.onerror = null;
            };
        } else {
            const finalFallbackUrl = `https://www.danishdesignstore.com/cdn/shop/files/${normalizedOption.replace(/[\(\)]/g, '')}.jpg`;
            previewImage.src = finalFallbackUrl;
            previewImage.onerror = null;
        }
    };
    
    // Set the initial image
    previewImage.src = imageUrl;
    previewImage.alt = `${fabricType} ${code}`;
    
    // For direct swatches, just show the code as the title to avoid duplication
    previewTitle.textContent = isDirect ? code : `${displayName || fabricType} - ${code}`;
    
    // Use the proper composition if available, otherwise leave empty
    previewDescription.textContent = (composition && composition.trim()) ? composition : '';
    
    // Update visual selected state for swatches
    document.querySelectorAll('#swatch-container-1 .swatches__form--label, #swatch-container-1 .swatch-item-inner').forEach(swatch => {
        const swatchParent = swatch.parentElement;
        const isSelected = swatch.dataset.fabricType === fabricType && swatch.dataset.swatchCode === code;
        
        if (swatchParent.classList.contains('swatch-item')) {
            swatchParent.classList.toggle('selected', isSelected);
        } else {
            swatch.classList.toggle('selected', isSelected);
        }
    });
}
   
// Update hidden secondary line item property
function updateSecondaryLineItem(fabricType, code, isDirect, fabricGroup, originalValue) {
    if (!selectedFabricInput) return;
    
    // Determine the fabric value based on the processing strategy
    let fabricValue = "";
    
    if (
        currentProcessingStrategy === 'upholsteryGroup' ||
        currentProcessingStrategy === 'simpleOptionSwatches' ||
        currentProcessingStrategy === 'nestedOptionGroups'
    ) {
        // For Upholstery Group, use the full "fabricType - code" format
        fabricValue = `${fabricType} - ${code}`;
    } else if (currentProcessingStrategy === 'upholstery') {
        // For general Upholstery, just use the code
        fabricValue = code;
    } else if (currentProcessingStrategy === 'direct') {
        // For Direct strategy, don't set any value
        fabricValue = "";
    }

    // Update the secondary fabric property
    selectedFabricInput.value = fabricValue;
    
    // Get the option name from the jsonLoader
    const optionName = jsonLoader.dataset.optionName || jsonLoader.dataset.optionTitle || 'Secondary Fabric';
    
    // Also update any property field that might exist for this option
    const propertyInput = document.querySelector(`input[name="properties[${optionName}]"]`);
  
    if (propertyInput && propertyInput !== fabricGroup) {
        propertyInput.value = fabricGroup;
        
        // Trigger change event to ensure any listeners know it's updated
        const event = new Event('change', { bubbles: true });
        propertyInput.dispatchEvent(event);
    }

    // Determine the correct search value - prioritize category groups for non-direct swatches
    let searchValue;
    if (fabricGroup && !isDirect) {
        // For category-based swatches (e.g. CAT 2), use the category name
        searchValue = fabricGroup.toLowerCase();
    } else if (originalValue) {
        // Fall back to original value if provided
        searchValue = originalValue.toLowerCase();
    } else {
        // Last resort: use fabric type
        searchValue = fabricType.toLowerCase();
    }
    
    // FIXED: Only find variant inputs for option index 2 (Secondary Fabric)
    // Look for the specific swatch group with data-option-index="2"
    const optionGroup = document.querySelector('.swatch[data-option-index="2"]');
    if (!optionGroup) return;
    
    // Now only search within this specific option group
    const allVariantInputs = Array.from(optionGroup.querySelectorAll('input.swatches__form--input'));
    
    if (allVariantInputs.length === 0) return;
    
    const searchLower = searchValue.toLowerCase();
    let exactMatch = null;
    let partialMatch = null;
    
    for (const input of allVariantInputs) {
        const inputValue = input.value.toLowerCase();
        const label = document.querySelector(`label[for="${input.id}"]`);
        const labelText = label ? label.textContent.toLowerCase() : '';
    
        // First, check for exact match in input or label
        if (inputValue === searchLower || labelText === searchLower) {
            exactMatch = input;
            break;
        }
    
        // Then, save first partial match as fallback
        if (
            !partialMatch &&
            (inputValue.includes(searchLower) || labelText.includes(searchLower))
        ) {
            partialMatch = input;
        }
    }
    
    const matchedVariant = exactMatch || partialMatch;

    // If we found a match, click it to select AND update the category in properties
    if (matchedVariant) {
        
        // First, get the actual option text this represents
        let selectedOptionText = "";
        const optionLabel = document.querySelector(`label[for="${matchedVariant.id}"]`);
        
        if (optionLabel) {
            selectedOptionText = optionLabel.textContent.trim();

            if(!selectedOptionText) {
              // Fallback: try to extract option from searchValue
              selectedOptionText = searchValue.charAt(0).toUpperCase() + searchValue.slice(1);
            }
        } else {
            // Fallback: try to extract option from searchValue
            selectedOptionText = searchValue.charAt(0).toUpperCase() + searchValue.slice(1);
        }
        
        // 1. Update the line item property for the category
        // Find the option's property input
        const propertyInput = document.querySelector(`input[name="properties[${optionName}]"]`);
        
        if (propertyInput) {
            propertyInput.value = selectedOptionText;
            
            // Trigger change event to ensure any listeners know it's updated
            const event = new Event('change', { bubbles: true });
            propertyInput.dispatchEvent(event);
        }
        
        // 2. Click the radio button to update the visible selection
        matchedVariant.click();
    }
}
  
   // Add event listeners to all swatches
   function attachSwatchListeners() {
       // Handle swatch clicks - only target the swatches in the secondary container
       document.querySelectorAll('#swatch-container-1 .swatches__form--label, #swatch-container-1 .swatch-item-inner').forEach(swatch => {
           swatch.addEventListener('click', handleSwatchClick);
       });
   }
   
   // Initialize fabric swiper (slider)
   function initializeSlider(sliderContainer, slideCount) {
       if (!sliderContainer) return;
       
       const sliderWrapper = sliderContainer.querySelector('.fabric-swiper-wrapper');
       const slides = Array.from(sliderContainer.querySelectorAll('.fabric-slide'));
       const nextBtn = sliderContainer.querySelector('.flickity-button.next.fabric-nav-btn');
       const prevBtn = sliderContainer.querySelector('.flickity-button.previous.fabric-nav-btn');
       
       if (!sliderWrapper || slides.length === 0) return;
       
       // Hide navigation buttons if fewer than 2 slides
       if (slideCount < 2) {
           if (nextBtn) nextBtn.style.display = 'none';
           if (prevBtn) prevBtn.style.display = 'none';
           
           // Ensure single-slide swatches render immediately
           slides[0].style.display = 'block';
           const singleSlideSwatches = slides[0].querySelectorAll('.swatches__form--label[data-lazy-image]');
           singleSlideSwatches.forEach(swatch => {
               if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                   loadSwatchImage(swatch);
               }
           });
           return;
       }
       
       let currentIndex = 0;
       
       // Create a height observer div that will track the current slide's height
       const heightObserver = document.createElement('div');
       heightObserver.className = 'height-observer';
       heightObserver.style.cssText = 'position: absolute; width: 100%; height: 0; visibility: hidden; overflow: hidden; transition: none;';
       sliderContainer.appendChild(heightObserver);
       
       // Clear any previous slider setup
       slides.forEach(slide => {
           Object.assign(slide.style, {
               opacity: '1',
               position: 'relative',
               width: '100%',
               display: 'block',
               height: 'auto',
               paddingLeft: '60px',
               paddingRight: '60px',
               boxSizing: 'border-box'
           });
       });
       
       // Position the navigation buttons in a fixed position
       if (nextBtn) {
           Object.assign(nextBtn.style, {
               position: 'absolute',
               top: '50px',
               transform: 'translateY(-50%)',
               right: '15px',
               zIndex: '10'
           });
       }
       
       if (prevBtn) {
           Object.assign(prevBtn.style, {
               position: 'absolute',
               top: '50px',
               transform: 'translateY(-50%)',
               left: '15px',
               zIndex: '10'
           });
       }
       
       // Function to update the slider position
       function updateSlider() {
           // Update horizontal position
           if (sliderWrapper) {
               sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
           }
           
           // Update height immediately and after a delay
           requestAnimationFrame(() => {
               updateHeight();
               // Double check after all transitions
               setTimeout(updateHeight, 410); // Just after transition ends
           });
           
           // Load images for the current slide and adjacent slides
           loadImagesForCurrentSlide();
       }
       
       // Load images for current and adjacent slides
       function loadImagesForCurrentSlide() {
           const indices = [
               currentIndex - 1,
               currentIndex,
               currentIndex + 1
           ].filter(i => i >= 0 && i < slides.length);
           
           indices.forEach(index => {
               const slide = slides[index];
               const swatches = slide.querySelectorAll('.swatches__form--label[data-lazy-image]');
               swatches.forEach(swatch => {
                   if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                       loadSwatchImage(swatch);
                   }
               });
           });
       }
       
       // Function to accurately measure and update container height
       function updateHeight() {
           if (!slides[currentIndex]) return;
           
           const currentSlide = slides[currentIndex];
           
           // Clone the current slide into our height observer to get accurate height
           heightObserver.innerHTML = '';
           const clone = currentSlide.cloneNode(true);
           Object.assign(clone.style, {
               position: 'static',
               visibility: 'hidden',
               height: 'auto',
               width: '100%',
               transform: 'none',
               paddingLeft: '60px',
               paddingRight: '60px',
               boxSizing: 'border-box'
           });
           heightObserver.appendChild(clone);
           
           // Get height from the clone
           const slideHeight = clone.offsetHeight;
           
           // Set container height with a small buffer
           sliderContainer.style.height = `${slideHeight + 20}px`;
       }
       
       // Navigation button handler factory
       function createNavHandler(direction) {
           return function(e) {
               e.preventDefault();
               e.stopPropagation();
               
               if (direction === 'next') {
                   currentIndex = currentIndex >= slides.length - 1 ? 0 : currentIndex + 1;
               } else {
                   currentIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
               }
               
               updateSlider();
               return false;
           };
       }
       
       // Add button event listeners
       if (nextBtn) {
           nextBtn.disabled = false;
           nextBtn.addEventListener('click', createNavHandler('next'));
       }
       
       if (prevBtn) {
           prevBtn.disabled = false;
           prevBtn.addEventListener('click', createNavHandler('prev'));
       }
       
       // Initialize container styles
       Object.assign(sliderContainer.style, {
           overflow: 'hidden',
           position: 'relative',
           transition: 'height 0.4s ease-in-out'
       });
       
       // Initialize wrapper styles
       if (sliderWrapper) {
           Object.assign(sliderWrapper.style, {
               display: 'flex',
               transition: 'transform 0.4s ease-in-out',
               willChange: 'transform'
           });
       }
       
       // Initialize position and height
       updateSlider();
       
       // Add touch swiping capability for mobile
       let startX, moveX, initialTransform;
       let isDragging = false;
       let isTapping = false;
       let tapTarget = null;
       let touchStartTime = 0;

       if (sliderWrapper) {
           sliderWrapper.addEventListener('touchstart', (e) => {
               // Check if we're touching an interactive element (swatch)
               tapTarget = e.target.closest('.swatches__form--label, .swatch-item-inner');
               isTapping = !!tapTarget;
               touchStartTime = Date.now();
               
               startX = e.touches[0].clientX;
               initialTransform = currentIndex * 100;
               isDragging = true;
           }, {passive: true});
           
           sliderWrapper.addEventListener('touchmove', (e) => {
               if (!isDragging) return;
               
               moveX = e.touches[0].clientX;
               const diffX = Math.abs(startX - moveX);
               
               // If movement is more than 10px, it's definitely a swipe, not a tap
               if (diffX > 10 && isTapping) {
                   isTapping = false;
               }
               
               // Only apply transform if not tapping a swatch
               if (!isTapping) {
                   const translateX = (startX - moveX) / sliderContainer.offsetWidth * 100;
                   sliderWrapper.style.transform = `translateX(-${initialTransform + translateX}%)`;
               }
           }, {passive: true});
           
           sliderWrapper.addEventListener('touchend', (e) => {
               if (!isDragging) return;
               
               const touchDuration = Date.now() - touchStartTime;
               isDragging = false;
               
               // If this was a tap on a swatch, don't process as a swipe
               if (isTapping && tapTarget && touchDuration < 300) {
                   // Reset transform in case it was slightly moved
                   sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
                   return;
               }
               
               // Handle case where moveX is undefined (no movement occurred)
               if (typeof moveX === 'undefined') {
                   moveX = startX;
               }
               
               const diffX = startX - moveX;
               // Increase threshold for slide change to prevent accidental slides
               if (Math.abs(diffX) > 50) { // Threshold for slide change
                   if (diffX > 0) {
                       // Next slide
                       currentIndex = currentIndex >= slides.length - 1 ? 0 : currentIndex + 1;
                   } else {
                       // Previous slide
                       currentIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
                   }
               } else {
                   // Reset transform for small movements
                   sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
               }
               
               updateSlider();
           }, {passive: true});
       }
       
       // Add window resize handler
       window.addEventListener('resize', updateHeight);
       
       // Force height calculation after images or other resources load
       window.addEventListener('load', updateHeight);
       
       // Specially handle images loading
       slides.forEach(slide => {
           const images = slide.querySelectorAll('img');
           images.forEach(img => {
               if (img.complete) {
                   updateHeight();
               } else {
                   img.addEventListener('load', updateHeight);
               }
           });
       });
       
       // Set initial height after a delay to ensure rendering
       setTimeout(updateHeight, 100);
   }
   
   // Start loading data
   loadData();
   
   // Initialize 3D model texture handling with unified system
   const modelViewer = document.querySelector('modern-viewer');
   if (modelViewer) {
       // Pre-load base materials before setting up listeners
       preloadBaseMaterials().then(() => {
           modelViewer.addEventListener('load', () => {
               // Setup universal option listeners for all options
               setupUniversalOptionListeners();
               
               // Check if there's already a selected swatch and apply its texture
               setTimeout(() => {
                   const selectedSwatch = document.querySelector('.swatches__form--label.selected');
                   if (selectedSwatch) {
                       const fabricType = selectedSwatch.dataset.fabricType;
                       // Determine the option index based on the container
                       const container = selectedSwatch.closest('[id^="swatch-container-"]');
                       if (container) {
                           const optionIndex = parseInt(container.id.replace('swatch-container-', ''));
                           handleOptionChange(optionIndex, fabricType, selectedSwatch);
                       }
                   }
               }, 500);
           });
       });
       
       modelViewer.addEventListener('error', (event) => {
           // Silent error handling
       });
   } else {
       // Still setup universal listeners even without 3D model
       preloadBaseMaterials().then(() => {
           setupUniversalOptionListeners();
       });
   }
});